var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "manager-page",
      class: {
        "close-side-menu": this.$store.state.isOpen,
        "mini-side-menu": this.$store.state.isMini,
        "sm-side-menu-open": this.$store.state.isSmOpen,
      },
    },
    [
      _c("SideBar"),
      _c(
        "div",
        { staticClass: "manager-page-content-wrap" },
        [
          _c("NavBar"),
          _c(
            "div",
            {
              staticClass: "manager-page-content",
              attrs: { id: "manager-page-content" },
            },
            [
              _c(
                "keep-alive",
                [_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e()],
                1
              ),
              !_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e(),
            ],
            1
          ),
          _c("Footer"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }